var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthDiaryViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#febe10;}.cls-3{fill:#ffd77d;}.cls-4{fill:#fffbc5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.55,
    y: 0.23,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.55,
    y: 0.23,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "health_diary_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.87,
    y: 1.26,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.8,
    y: 75.92,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.79,270.39v314a17,17,0,0,1-17.26,16.84H17.08A17,17,0,0,1-.17,584.42V170.25a17,17,0,0,1,17.25-16.84H260.9a17.7,17.7,0,0,1,5.85,1l112.49,109A16.47,16.47,0,0,1,380.79,270.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.24,263.42H284.18a17.27,17.27,0,0,1-17.43-17.09V154.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.46,
    y: 372.68,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.97 1.43) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.57,
    y: 519.34,
    width: 133.75,
    height: 36.54,
    rx: 12,
    transform: "translate(-4.08 0.95) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.9,
    y: 299.6,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.41 1.42) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.01,
    y: 445.77,
    width: 261.49,
    height: 36.54,
    rx: 12,
    transform: "translate(-3.52 1.43) rotate(-0.44)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiaryViewEntries);
export default __webpack_public_path__ + "static/media/health_diary_view_entries.386a0ad2f4d03cebfe6c4a4b6587d35c.svg";
export { ForwardRef as ReactComponent };